import React, { useEffect, useState } from 'react';
import Snackbar from '@mui/material/Snackbar';

const MsgSnackBar = ({msgSnackOpen,setMsgSnackOpen,msg,vertical}) => {
  
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setMsgSnackOpen(false);
  };

  return (
      <Snackbar
        anchorOrigin={{ vertical: vertical, horizontal: 'center' }}
        open={msgSnackOpen}
        onClose={handleClose}
        message={msg}
        autoHideDuration={2000} // 2秒自动隐藏
      />
  );
};

export default MsgSnackBar;
